<template>
  <span class="count-badge">{{ displayCount }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface CountBadgeProps {
  count: number;
  /** Counts above this render as "N+" so the pill never outgrows its anchor. */
  max?: number;
}

const props = withDefaults(defineProps<CountBadgeProps>(), {
  max: 9,
});

const displayCount = computed(() => (props.count > props.max ? `${props.max}+` : `${props.count}`));
</script>

<style scoped lang="scss">
.count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  // One digit stays a circle; the side padding turns two or more characters into a pill, not an egg
  min-width: 1.125rem;
  height: 1.125rem;
  padding: 0 0.3125rem;
  border-radius: var(--t-border-radius-full-rounded);
  background: var(--t-color-orange-500);
  color: var(--t-color-neutral-white);
  font-size: 0.6875rem;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1;
}
</style>
